import React from 'react'

import { withToggles } from '@acorns/web-toggles-react'
import type { WithTogglesProps } from '@acorns/web-toggles-react'
import { GenericAnalyticsClient, withAnalyticsClient } from '@acorns/web-utils'
import { getWindow } from '@acorns/web-utils'
import { datadogRum } from '@datadog/browser-rum'

import PageNotFound from 'pages/404'

type Props = {
  analytics: GenericAnalyticsClient
} & WithTogglesProps

class ErrorBoundaryClass extends React.Component<Props, { hasError: boolean }> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: any) {
    this.props.analytics.track('Page Crash', {
      error: error.toString(),
      error_boundary_url_location: getWindow().location.href,
      enabled_feature_toggles: this.props.toggles.getAllEnabledFeatures(),
      ...info,
    })

    datadogRum.addError(error, { event: 'Page Crash' })
  }

  render() {
    if (this.state.hasError) {
      return (
        <PageNotFound message="We are sorry, an error has occurred. Our technical team is looking into this." />
      )
    }

    return this.props.children
  }
}

export const ErrorBoundary = withToggles(
  withAnalyticsClient(ErrorBoundaryClass),
)
